import { render, staticRenderFns } from "./OrdersSearchWidgetForm.vue?vue&type=template&id=41e80f2c"
import script from "./OrdersSearchWidgetForm.vue?vue&type=script&lang=js"
export * from "./OrdersSearchWidgetForm.vue?vue&type=script&lang=js"
import style0 from "./OrdersSearchWidgetForm.vue?vue&type=style&index=0&id=41e80f2c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports